import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { isNullOrUndefined } from 'util';
import SwitchButton from '../shared/switchButtonV4.jsx';


class ProdottoServiziEsterni extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showConfirm: false
        }
        this.componentName = '[ProdottoServiziEsterni.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
}

componentDidMount() {
    console.log(this.componentName + ' componentDidMount');

}

inputChangeHandler(e) {
    console.log(this.componentName + " inputChangeHandler");
    if (e !== null && e !== undefined) {

        let value = e.target.value;
        let id = e.target.id;
        let type = e.target.type;
        if (value === "[object Object]") {
            value = "";
        }

        if (type === "number" && value === "") {
            value = null;
        }

        if(type === "checkbox") {
            value = e.target.checked;
        }

        if (!isNullOrUndefined(type) && type === "radio") {
            id = e.target.name;
        }
        if (this.props.validation.has(id)) {
            this.props.validation.delete(id);
        }
        // else if (index === 'fineValidita' && value ) {
        // }
        this.props.handleChange(id, value)
    }
}

render() {
    console.log(this.componentName + ' render');
    return (
        <div>
        <div className="row mt-4 rowServizioEsterno">
                <div className="col-6 col-sm-6 col-md-4 col-lg-2" style={{display: 'flex', alignItems: 'center'}}>
                    {i18n('ARM_CORE_PRODUCT.SHARED.EMISSIONE_ESTERNA', 'EMISSIONE ESTERNA  ')}
                </div>
                <SwitchButton
                    id="flEmissioneEsterna"
                    value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.flEmissioneEsterna : null}
                    label=""
                    onChange={this.inputChangeHandler}
                    componentClass="col-6 col-sm-6 col-md-2 col-lg-1"
                    disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                />
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flEmissioneEsterna && 
                    <agui.ATextInputV4 id="urlEmissione" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.urlEmissione : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.URL_EMISSIONE', 'URL del servizio')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flEmissioneEsterna && 
                    <agui.ATextInputV4 id="usernameEmissione" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.usernameEmissione : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.USERNAME_EMISSIONE', 'Username')}
                        onChange={this.inputChangeHandler}
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flEmissioneEsterna && 
                    <agui.ATextInputV4 id="passwordEmissione" type="password"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.passwordEmissione : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.PASSWORD_EMISSIONE', 'Password')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
             </div>

             <div className="row rowServizioEsterno">
                    <div className="col-6 col-sm-6 col-md-4 col-lg-2" style={{display: 'flex', alignItems: 'center'}}>
                        {i18n('ARM_CORE_PRODUCT.SHARED.QUOTAZIONE_ESTERNA', 'QUOTAZIONE ESTERNA')}
                    </div>
                    <SwitchButton
                        id="flQuotazioneEsterna"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.flQuotazioneEsterna : null}
                        label=""
                        onChange={this.inputChangeHandler}
                        componentClass="col-6 col-sm-6 col-md-2 col-lg-1"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                    />
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flQuotazioneEsterna && 
                    <agui.ATextInputV4 id="urlQuotazione" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.urlQuotazione : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.URL_QUOTAZIONE', 'URL del servizio')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        
                        />
                }
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flQuotazioneEsterna && 
                    <agui.ATextInputV4 id="usernameQuotazione" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.usernameQuotazione : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.USERNAME_QUOTAZIONE', 'Username')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flQuotazioneEsterna && 
                    <agui.ATextInputV4 id="passwordQuotazione" 
                        type="password"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.passwordQuotazione : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.PASSWORD_QUOTAZIONE', 'Password')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
            </div>







            <div className="row rowServizioEsterno">
                    <div className="col-6 col-sm-6 col-md-4 col-lg-2" style={{display: 'flex', alignItems: 'center'}}>
                        {i18n('ARM_CORE_PRODUCT.SHARED.PROPOSTA_ESTERNA', 'PROPOSTA ESTERNA')}
                    </div>
                    <SwitchButton
                        id="flPropostaEsterna"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.flPropostaEsterna : null}
                        label=""
                        onChange={this.inputChangeHandler}
                        componentClass="col-6 col-sm-6 col-md-2 col-lg-1"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                    />
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flPropostaEsterna && 
                    <agui.ATextInputV4 id="urlProposta" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.urlProposta : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.URL_PROPOSTA', 'URL del servizio')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        
                        />
                }
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flPropostaEsterna && 
                    <agui.ATextInputV4 id="usernameProposta" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.usernameProposta : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.USERNAME_PROPOSTA', 'Username')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
                {this.props.prodottoServiziEsterni && this.props.prodottoServiziEsterni.flPropostaEsterna && 
                    <agui.ATextInputV4 id="passwordProposta" 
                        type="password"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.passwordProposta : null}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.PASSWORD_PROPOSTA', 'Password')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        validation={this.props.validation}
                        required
                        />
                }
            </div>







            <div className="row">
                    <agui.ATextInputV4 id="codEsterno" type="text"
                        value={this.props.prodottoServiziEsterni ? this.props.prodottoServiziEsterni.codEsterno : null}
                        info={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.INFO_CODICE_ESTERNO', 'Info: Codice Usato dalla compagnia per il prodotto')}
                        label={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.CODICE_ESTERNO', 'Codice Esterno')}
                        placeholder={i18n('ARM_CORE_PRODUCT.PRODOTTOSERVIZIO.INSERIRE_CODESTERNO', 'inserire codEsterno')}
                        onChange={this.inputChangeHandler} 
                        componentClass="col-12 col-sm-12 col-md-6 col-lg-3 mt-2"
                        disabled={this.props.source !== "prodottoCreate" || ( !isNullOrUndefined(this.props.prodotto.numEmissioni) && this.props.prodotto.numEmissioni > 0)}
                        />
            </div>
        </div>
        

    )
}
;
}
function mapStateToProps(state) {
    return {
        prodottoServiziEsterni: state.prodotto.prodottoServiziEsterni,
        prodotto: state.prodotto.detailsProdotto
    }
}

function mapDispatchToProps(dispatch) {
    return {
        handleChange(index, e) {
            return dispatch(ProdottoActions.handleChangeServiziEsterni(index, e))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProdottoServiziEsterni);